import { RequestContext } from "../request-context";
import { WatchlistArgs } from "./watchlist";
import { LibraryArgs } from "./library";
import { DVString, Link, WithRequestID } from "./shared";
import { ChannelArgs } from "./channel";
import {VideoMaterialType} from './shared';

export interface MyStuffFeatureContent {}

export enum MyStuffViewType {
    WatchlistMyStuffView = 'watchlist',
    LibraryMyStuffView = 'library',
    ChannelMyStuffView = 'channel',
    ErrorMyStuffView = 'error'
}

export enum MyStuffFeatureType {
    LegacyWatchlistMyStuffFeature = 'legacy-watchlist',
    LegacyLibraryMyStuffFeature = 'legacy-library',
    ChannelMyStuffFeature = 'channel',
    ErrorMyStuffFeature = 'error',
    PartialErrorWarningMyStuffFeature = 'partial-error-warning',
    ViewFilterMyStuffFeature = 'view-filter'
}

export interface MyStuffViewArgs {
    watchlist?: WatchlistArgs;
    library?: LibraryArgs;
    channel?: ChannelArgs;
    shared: SharedInput;
}

export interface SharedInput {
    isPurchaseRow: boolean;
}

export interface MyStuffInput {
    context: RequestContext;
    viewType: MyStuffViewType;
    args: string | MyStuffViewArgs;
}

export interface MyStuffViewOutput {
    viewType: MyStuffViewType;
    features: MyStuffFeatureContentMap;
}

export type MyStuffFeatureContentMap = {
    [key in MyStuffFeatureType]?: MyStuffFeatureContent
}

export interface ErrorContent extends MyStuffFeatureContent {
    message: DVString;
}

export interface ViewFiltersModel extends MyStuffFeatureContent {
    filters: ViewFilter[];
}

export interface ViewFilter extends Link {
    active: boolean;
    viewType: MyStuffViewType;
}

export interface MyStuffOutput extends WithRequestID {
    viewOutput: MyStuffViewOutput
}

export interface MyStuffItemPlaybackAction {
    refMarker: string,
    videoMaterialType?: VideoMaterialType,
    resumeTime?: number,
    fallbackUrl?: string,
    titleID?: string
}
